import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatiquePageService {


  constructor(private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };

  getPageByName(name,url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('Pages')/items?"
    +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=substringof('"+ name +"',FileLeafRef)",this.httpOptions);
  
}
getPageByNameSection(name,url, section){
  return this.http.get(url+"/_api/web/lists/GetByTitle('Pages')/items?"
  +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=substringof('"+ name +"',FileLeafRef) and (Section eq '"+section +"')",this.httpOptions);

}
getMenuBySection(section, url) {
  return this.http.get(url+"/_api/web/lists/GetByTitle('MenuNavigation')/items?"
  +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=Section eq '"+section +"'",this.httpOptions);
}
getMenu(url) {
  return this.http.get(url+"/_api/web/lists/GetByTitle('MenuNavigation')/items?"
  +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File",this.httpOptions);
}
getPhototheque(url) {
  return this.http.get(url+"/_api/web/lists/GetByTitle('Phototheque')/items?"
  +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File",this.httpOptions);
}
getPhotothequeFolder(url, folderUrl) {
  return this.http.get(url + "/_api/web/lists/getByTitle('Phototheque')/Items?"
  + "$select=*,FileDirRef,FileLeafRef&$filter=FileDirRef eq '"+ folderUrl +  "'",this.httpOptions);
}

}
